(ns ycweb.app.website.myaccount.cookingschool.cookingschool
  (:require
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.common :as cmn]))

;TODO Update IDs to UUID when cooking school is done in SPA
(rum/defc school-line [app-atom course]
  [:tr.yc-tr
   [:td
    {:class (u/bem :yc-td [:product-text])}
    [:span.yc-td__faux-table {:data-th "Course"}
     [:span.yc-td__faux-td
      [:a.text-link {:href (str "/cooking-school.htm?action=courseregister&id=" (:course/id course))} (:course/title course)]]]]
   [:td
    {:class (u/bem :yc-td [:centered])}
    [:span.yc-td__faux-table {:data-th "Options"}
     [:span.yc-td__faux-td
      (buttons/button-web "Start course"
        {:href (str "/cooking-school.htm?action=mycourseview&uuid=" (:ent/uuid course))
         :style :light
         :size :small})]]]])

(rum/defc school-table [app-atom courses]
  [:table
   {:class (u/bem :yc-table [:order-view])}
   [:caption.yc-table-caption.hidden-from-view
    "View Yuppiechef Cooking School courses that you have access to"]
   [:colgroup
    [:col]
    [:col {:style {:width "120px"}}]]
   [:thead.yc-thead
    [:tr.yc-tr
     [:th.yc-th {:scope "col"} "Course"]
     [:th
      {:class (u/bem :yc-th [:centered])
       :scope "col"} "Options"]]]

   (into
     [:tbody.yc-tbody]
     (map
       (partial school-line app-atom)
       courses))])

(rum/defc school < rum/reactive [app-atom]
  (let [{:keys [school] :as state} (rum/react (cmn/action-cursor app-atom))
        membership (not-empty (:school-membership school))
        courses (not-empty (:school-courses school))]
    [:div.dashboard
     (headings/heading "Cooking School Courses" {:type :h2 :size :medium})

     (when membership
       [:div
        {:class (u/bem :no-data-wrapper :yc-section [:standard])}
        [:div.no-data-view
         [:p "Your Cooking School Membership is active."]
         [:div
          {:class (u/bem :button-wrapper [:align-center])}
          (buttons/button-web "Start a course"
            {:href "/cooking-school.htm?action=my-courses"
             :style :dark})]]])

     (cond
       courses
       (school-table app-atom courses)

       (not membership)
       [:div
        {:class (u/bem :no-data-wrapper :yc-section [:standard])}
        [:div.no-data-view
         [:p "You don't have access to any Cooking School courses"]]])
     (toaster/loading-overlay app-atom :web.myaccount/school)]))

(defmethod flow/render-screen :web.myaccount/school [app-atom _]
  (awm.common/screen-wrapper app-atom
    (school app-atom)))

(defmethod t/transition-open :web.myaccount/school [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/school)
  (comms/ajax-get :web.myaccount/school {}))

(defmethod comms/receive :web.myaccount/school [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/school)
  (swap! (cmn/action-cursor app-atom) assoc
    :school
    {:school-membership (:school-membership e)
     :school-courses (:school-courses e)}))
